<template>
  <div class="tabbed">
    <div class="tabbed__tabs">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="tabbed__tab"
        :class="{ 'tabbed__tab--active': tab.isActive }"
        @click="selectTab(tab)"
      >
        {{ tab.name }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script>

  export default {
    data() {
      return {tabs: []};
    },
    created() {
      this.tabs = this.$children;
    },
    methods: {
      selectTab(selectedTab) {
        this.tabs.forEach(tab => {
          tab.isActive = (tab.name == selectedTab.name);
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .tabbed {
    box-shadow: 0 2px 5px 0 rgba($bali, 0.25);
    overflow: hidden;
    &__tabs {
      display: flex;
    }
    &__tab {
      position: relative;
      background: $white;
      color: $primary;
      padding: $card-padding-y $card-padding-x;
      border-bottom: solid 3px transparent;
      font-weight: bold;
      text-align: center;
      line-height: $headings-line-height;
      flex: 1;
      background: $zircon;
      cursor: pointer;
      @include transitionOut();
      @include minpoint(tablet) {
        font-size: $font-size-lg;
      }
      &:first-child {
        border-radius: 4px 0 0 0;
      }
      &:last-child {
        border-radius: 0 4px 0 0;
      }
      &--active {
        pointer-events: none;
        background: $white;
        border-color: $tangerine;
        box-shadow: 0 2px 5px 0 rgba($bali, 0.25);
        position: relative;
        z-index: $z-tabs;
        @include transitionIn();
      }
    }
    &__content {
      position: relative;
      z-index: $z-tabs;
    }
  }
</style>
